<template>
  <div class="d-contents">
    <div v-for="i in count" :key="i" class="cell" />
  </div>
</template>

<script>
  export default {
    name: 'EmptyCell',
    props: {
      count: {
        type: Number,
        default: 1,
      },
    },
  };
</script>
